import { createSlice } from "@reduxjs/toolkit";
import { firestore } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";

const initialState = {
  especes: [],
  souches: [],
  isLoading: false,
  error: false,
};

export const especeSlice = createSlice({
  name: "souche",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // GET Souches
    getSouchesSuccess(state, action) {
      state.isLoading = false;
      state.souches = action.payload;
    },

    // GET EspeceS
    getEspecesSuccess(state, action) {
      state.isLoading = false;
      state.especes = action.payload;
    },
    // create souche
    createSoucheSuccess(state, action) {
      state.souches.push(action.payload);
    },
    // update souche
    updateSoucheSuccess(state, action) {
      state.souches = state.souches.map((souche) => {
        if (souche.id === action.payload.id) {
          return action.payload;
        }
        return souche;
      });
    },
    // delete souche
    deleteSoucheSuccess(state, action) {
      const { id } = action.payload;
      state.souches = state.souches.filter((souche) => souche.id !== id);
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  startLoading,
  hasError,
  getEspecesSuccess,
  getSouchesSuccess,
  createSoucheSuccess,
  updateSoucheSuccess,
  deleteSoucheSuccess,
} = especeSlice.actions;

// create souche function

export const createSouche = (data) => async (dispatch) => {
  const { name, especeID } = data;
  const docRef = collection(firestore, "souche");
  const newData = {
    name: name,
    especeID: especeID,
    timestamp: serverTimestamp(),
    // other fields
  };
  try {
    dispatch(startLoading());
    const addedDocRef = await addDoc(docRef, newData);
    const id = addedDocRef.id;
    // Update the document with the ID
    const docToUpdate = doc(firestore, "souche", id);
    await updateDoc(docToUpdate, { id });
    dispatch(createSoucheSuccess({ ...newData, id }));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// get souches

export const getSouches = () => async (dispatch) => {
  try {
    dispatch(startLoading());
    const querySnapshot = await getDocs(collection(firestore, "souche"));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    dispatch(getSouchesSuccess(data));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// update souche

export const updateSouche = (data) => async (dispatch) => {
  const { id, name, especeID } = data;
  const docRef = doc(firestore, "souche", id);
  try {
    dispatch(startLoading());
    await updateDoc(docRef, { name, especeID });
    dispatch(updateSoucheSuccess({ id, name, especeID }));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// delete souche

export const deleteSouche = (id) => async (dispatch) => {
  const docRef = doc(firestore, "souche", id);
  try {
    dispatch(startLoading());
    await deleteDoc(docRef);
    dispatch(deleteSoucheSuccess({ id }));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// get Especes from firestore
export const getEspeces = () => async (dispatch) => {
  try {
    dispatch(startLoading());
    const querySnapshot = await getDocs(collection(firestore, "espece"));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    dispatch(getEspecesSuccess(data));
  } catch (error) {
    dispatch(hasError(error));
  }
};

export default especeSlice.reducer;
